var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserGroupsClient } from "@/app/api/battery-portal-api";
import RouteNames from "@/app/router/routes";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import { Component, Vue } from "vue-facing-decorator";
const userGroupsClient = new UserGroupsClient(window.apiUrl);
let UserGroupsVue = class UserGroupsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.loaded = false;
        this.showInfoMessage = true;
        this.groups = [];
    }
    created() {
        this.load();
    }
    ;
    load() {
        this.working = true;
        userGroupsClient
            .getList()
            .then((response) => {
            this.groups = response || [];
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    ;
    edit(group) {
        this.$router.push({ name: RouteNames.UserGroup, params: { id: group.userGroupId.toString() } });
    }
    ;
    remove(group) {
        if (this.working)
            return;
        this.$confirmModal.show(`Are you sure that you want to delete the user group '${group.name}'? Its members will lose the features it switches on.`, { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            userGroupsClient
                .delete(group.userGroupId)
                .then(() => {
                this.groups = this.groups.filter(g => g.userGroupId !== group.userGroupId);
                Notifier.onOk(`User group '${group.name}' has been deleted.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    get noData() {
        return this.loaded && !this.groups.length;
    }
    ;
};
UserGroupsVue = __decorate([
    Component({
        name: "UserGroupsVue"
    })
], UserGroupsVue);
export default UserGroupsVue;
